<template>
  <div id="app">
    <!--<router-view/>-->
    <transition name="fade-left">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive&&iWidth!=null" :class="iWidth>500?'router-view-750':'router-view'">
        </router-view>
      </keep-alive>
    </transition>
    <!-- 底部 tab 体系内页面不套 transition，切换时只替换内容，避免旧页面文字短暂残留。 -->
    <router-view v-if="showPlainTabRouterView" :class="iWidth>500?'router-view-750 router-view-tab':'router-view router-view-tab'">
    </router-view>
    <transition :name="pageTransitionName">
      <router-view v-if="showTransitionRouterView" :class="iWidth>500?'router-view-750':'router-view'">
      </router-view>
    </transition>
    <!-- 共享底部 tab 固定在 router-view 外层，避免 tab 页切换时底栏跟随页面销毁重建。 -->
    <checkin-bottom-tab v-if="showSharedBottomTab" :active="activeBottomTab"></checkin-bottom-tab>
  </div>
</template>
<script>
import { getToken, getPc, configApi } from "@/utils/common";
import config from "@/utils/config";
import router from "@/router/index";
import CheckinBottomTab from "@/components/CheckinBottomTab.vue";
export default {
  name: "App",
  components: {
    CheckinBottomTab,
  },
  data() {
    return {
      // pageTransitionName 保存普通页面默认切换动画名，必须声明为响应式字段供模板绑定使用。
      pageTransitionName: "fade-left",
      // iWidth 保存首屏容器宽度，渲染 router-view 前用于决定移动端/PC 容器样式。
      iWidth: null,
      // prevRouteName 保存上一个路由名，供后续需要按路由方向调整转场时复用。
      prevRouteName: "",
    };
  },
  computed: {
    showSharedBottomTab() {
      // 只有底部 tab 体系内页面展示共享底栏，详情页等沉浸页面不受影响。
      return ["myCheckin", "createDefault", "createDefaultRoot", "notice", "personal"].indexOf(this.$route && this.$route.name) > -1;
    },
    showPlainTabRouterView() {
      // tab 页使用普通 router-view，路由切换时不会保留离场 DOM。
      return !this.$route.meta.keepAlive && this.iWidth != null && this.showSharedBottomTab;
    },
    showTransitionRouterView() {
      // 非 tab 页保留原有转场效果。
      return !this.$route.meta.keepAlive && this.iWidth != null && !this.showSharedBottomTab;
    },
    activeBottomTab() {
      // 路由名和组件高亮名解耦，便于新增同属一个 tab 的子页面。
      const activeMap = {
        myCheckin: "myCheckin",
        createDefault: "create",
        createDefaultRoot: "create",
        notice: "notice",
        personal: "personal",
      };
      return activeMap[this.$route && this.$route.name] || "";
    },
  },
  watch: {
    $route(to, from) {
      this.prevRouteName = (from && from.name) || "";
    },
  },
  created() {
    configApi(
      function (res) { },
      function (err) { }
    );
  },
  mounted() {
    // 获取一下url，如果是哈希就强转成history，去掉井号
    var url = window.location.href;
    if (url.indexOf("/#/") != -1) {
      url = url.replace("/#/", "/");
      window.location.href = url;
    }
    var iWidth = document.documentElement.clientWidth;
    var myWidth = document.documentElement.clientWidth;
    config.MyWidth = myWidth;

    if (document.documentElement.clientWidth > 500) {
      // 电脑端:容器宽度 500px,rem 基准值设为 37.5px (原 75px 的 50%)
      this.iWidth = iWidth;
      document.getElementsByTagName("html")[0].style.fontSize = "37.5px";
    } else {
      // 手机端保持原有的自适应逻辑
      this.iWidth = iWidth;
      if (myWidth > 500) myWidth = 500;
      document.getElementsByTagName("html")[0].style.fontSize = myWidth / 10 + "px";
    }

    let vid = this.$route.query.vid;
    if (vid) {
      config.Vid = vid;
    }
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  /* background: #f5f5f5; */
}

.router-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  /* height: 100%;  */
  transition: all 0.5s cubic-bezier(0.5, 0, 0.1, 1);
}
.router-view-750 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 500px;
  min-height: 100%;
  margin: auto;
  transition: all 0.5s cubic-bezier(0.5, 0, 0.1, 1);
  /* background: #fff; */
  box-sizing: border-box;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.router-view-tab {
  transition: none;
}

.router-view-750.router-view-tab {
  box-shadow: none;
}

.fade-left-enter,
.fade-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.fade-left-leave-active,
.fade-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue